import moment from 'ct-moment'

export const parseZoneDate = (dateTime) => moment.parseZone(dateTime).format(moment.HTML5_FMT.DATE)

export const roundTimeUp = (minuteInterval, momentTime) => {
  // adapted from: https://github.com/moment/moment/issues/959
  const roundedMinutes = Math.ceil(momentTime.minute() / minuteInterval) * minuteInterval;
  return momentTime.clone().minute(roundedMinutes).second(0)
}
